export const SET_BRAND = 'SET_BRAND'
export const SET_PRODUCT = 'SET_PRODUCT'

export const SET_MIN_PRICE = 'SET_MIN_PRICE'
export const SET_MAX_PRICE = 'SET_MAX_PRICE'

export const REMOVE_BRAND = 'REMOVE_BRAND'
export const REMOVE_PRODUCT = 'REMOVE_PRODUCT'
export const REMOVE_MIN_PRICE = 'REMOVE_MIN_PRICE'
export const REMOVE_MAX_PRICE = 'REMOVE_MAX_PRICE'